import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class widgetTag extends Component{
	render(){
		return(
			<>
				<div className="widget widget_tag_cloud">
					<h4 className="widget-title">ETIQUETAS</h4>
					<div className="tagcloud"> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link>
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link> 
						<Link to="#">XXXXXXX</Link>
					</div>
				</div>
				
			</>
		);
	}
}

export default widgetTag;